import { Dispatch, SetStateAction, useState } from 'react';

export interface TrackedTriggerHook {
    hasNewTrigger: boolean;
    setTrackedTriggers: Dispatch<SetStateAction<string[]>>;
}

const useTrackedTriggers = (currentTriggers: string[]): TrackedTriggerHook => {
    const [previousTriggers, setPreviousTriggers] = useState([]);
    const isSameLength = currentTriggers.length === previousTriggers.length;

    return { hasNewTrigger: !isSameLength, setTrackedTriggers: setPreviousTriggers };
};

export default useTrackedTriggers;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/messages/components/CircumventionWarning/useTrackedTriggers.tsx